export default "__VITE_ASSET__CIlLUjA1__"